<script setup lang="ts">

import BasicStepperItem from "./BasicStepperItem.vue";

type IProps = {
  maxSteps: number;
  currentStep: number;
}
const props = defineProps<IProps>();
</script>

<template>
  <div class="w-full">
    <div class="flex items-center">
      <BasicStepperItem
        v-for="index in props.maxSteps"
        :is-first="index === 1"
        :is-active="index == props.currentStep"
        :is-success="index < props.currentStep"
        :value="'' + index"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>